import { createSelector } from 'reselect'
import { featureStateSelector } from './featureStateSelector'

export const campaignLevelRowsSelector = createSelector(featureStateSelector, state => state.campaignLevelList)

export default campaignLevelRowsSelector
